import { render, staticRenderFns } from "./UserTrainings.vue?vue&type=template&id=77959b89&scoped=true&"
import script from "./UserTrainings.vue?vue&type=script&lang=js&"
export * from "./UserTrainings.vue?vue&type=script&lang=js&"
import style0 from "./UserTrainings.vue?vue&type=style&index=0&id=77959b89&lang=scss&scoped=true&"
import style1 from "./UserTrainings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77959b89",
  null
  
)

export default component.exports